<template>
  <v-container 
    fluid 
    grid-list-lg>
    <v-layout 
      row 
      wrap>
      <v-flex
        xs12
        sm12
        md8
        lg8
        xl8
        offset-lg2
        offset-md2
        offset-xl2
        v-html="localizedMisc.introduction"/>
      <v-flex
        xs12
        sm12
        md8
        lg8
        xl8
        offset-lg2
        offset-md2
        offset-xl2>
        <h2 class="display-5"><v-icon>work</v-icon> {{ $t("experience") }}</h2>
        <experience-item 
          v-for="experience in localizedExperiences" 
          :key="experience.id" 
          :experience="experience"
          :printer_off="printer_off"/>
      </v-flex>
      <v-flex
        xs12
        sm12
        md8
        lg8
        xl8
        offset-lg2
        offset-md2
        offset-xl2 
        class="page_break_after">
        <h2 class="display-5"><v-icon>school</v-icon> {{ $t("education") }}</h2>
        <education-item 
          v-for="school in localizedSchools" 
          :key="school.id" 
          :school="school"/>
      </v-flex>
      <v-flex
        xs12
        sm12
        md8
        lg8
        xl8
        offset-lg2
        offset-md2
        offset-xl2 
        class="page_break_before no_break_inside">
        <h2 class="display-5"><v-icon>verified_user</v-icon> {{ $t("certifications") }}</h2>
        <v-container 
          grid-list-md 
          class="pa-2">
          <v-layout 
            row 
            wrap>
            <acclaim-badge 
              v-for="badge in acclaimBadges" 
              :key="badge.id" 
              :printer_off="printer_off" 
              :badge="badge" 
              class="w50_on_print"/>
            <v-flex 
              sm12 
              md12 
              lg6 
              class="text-xs-center w50_on_print">
              <v-card class="px-5 py-2">
                <a 
                  target="_blank" 
                  href="https://umbraco.com/training/certified-developers/developer/?id=5c368fe8-7a8e-4d74-a886-7d32618c4540" 
                  style="height:260; display: block;">
                  <v-img 
                    class="umbraco_badge" 
                    src="/images/badges-2-03.png"/>
                </a>
                <v-card-text>Umbraco Fundamentals Certification<br >September 2019 - Expired<!-- <a 
                  href="https://umbraco.com/training/certified-developers/developer/?id=5c368fe8-7a8e-4d74-a886-7d32618c4540" 
                  target="_blank">View on Umbraco.com <ion-icon name="open"/></a> --></v-card-text>
              </v-card>
            </v-flex>
            <v-flex 
              sm12 
              md12 
              lg6 
              class="text-xs-center w50_on_print">
              <v-card class="px-5 py-2">
                <a 
                  target="_blank" 
                  href="https://umbraco.com/training/certified-developers/developer/?id=5c368fe8-7a8e-4d74-a886-7d32618c4540">
                  <v-img 
                    class="umbraco_badge" 
                    src="/images/badges-2-03.png"/>
                </a>
                <v-card-text>Umbraco Cloud Certification<br >November 2019 - Expired<br v-if="!printer_off"><br v-if="!printer_off"><!-- <a 
                  href="https://umbraco.com/training/certified-developers/developer/?id=5c368fe8-7a8e-4d74-a886-7d32618c4540" 
                  target="_blank">View on Umbraco.com <ion-icon name="open"/></a> --></v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.umbraco_badge {
  max-width: 300px;
  margin-right: auto;
  margin-left: auto;
}
.normal-list li {
  list-style: disc inside;
  display: list-item;
  text-align: left;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
@media print {
.container.grid-list-lg .layout .flex {
    padding: 0;
}
.page_break_before {
  break-before: avoid;
  page-break-before: always;
}
.page_break_after {
  break-after: avoid;
  page-break-after: always;
}
.no_break_inside {
  page-break-inside: avoid;
  break-inside: avoid;
}
/* .print_break_before {
  break-before: page;
  break-after: page;
} */
.layout.wrap {
  display: block;
  position: relative;
  width: 100%;
}
  .w50_on_print {
    width: 50%;
    display: inline-block;
  }
}
</style>

<script>
import axios from 'axios';
import ExperienceItem from "../components/ExperienceItem.vue";
import EducationItem from "../components/EducationItem.vue";
import AcclaimBadge from "../components/AcclaimBadge.vue";
// import Experiences from "../Data/Experiences/en.json";
  export default {
    components: {
      'experience-item': ExperienceItem,
      'education-item': EducationItem,
      'acclaim-badge': AcclaimBadge
    },
    props: {
        printer_off: {
          type: Boolean,
          default: true
        }
    },
    data () {
      return {
        experienceLangs: [],
        schoolLangs: [],
        miscLangs: [],
        acclaimBadges: [
          {
            id: "1dc267bd-b7aa-4887-a672-7a1016368dd7",
            name: "Exam 483: Programming in C#",
            printName: "Exam 483:<br>Programming in C#",
            printIssuer: "Microsoft"
          },
          {
            id: "457c6f98-a06e-44f7-80d7-792bbf1706c9",
            name: "MTA: Software Development Fundamentals - Certified 2017",
            printName: "MTA: Software Development Fundamentals - Certified 2017",
            printIssuer: "Microsoft"
          }
        ]
      }
    },
    computed: {
      localizedExperiences: function () {
        var res = this.experienceLangs.find(l => l.lang === this.$i18n.locale);
        if(res && res.lang !== undefined) {
          return res.experiences;
        }
        else {
          return [];
        }
      },
      localizedSchools: function () {
        var res = this.schoolLangs.find(l => l.lang === this.$i18n.locale);
        if(res && res.lang !== undefined) {
          return res.school;
        }
        else {
          return [];
        }
      },
      localizedMisc: function () {
        var res = this.miscLangs.find(l => l.lang === this.$i18n.locale);
        if(res && res.lang !== undefined) {
          return res.misc;
        }
        else {
          return {};
        }
      }
    },
    mounted() {
      this.getExperienceLangs();
      this.getSchoolLangs();
      this.getMiscLangs();
    },
    methods: {
      getExperienceLangs() {
        Object.keys(this.$i18n.messages).map((key) => {
          let that = this;
          axios.get('/data/Experiences/' + key + '.json').then(function (response) {
            that.experienceLangs.push({ lang: key, experiences: response.data })
          });
        });
      },
      getSchoolLangs() {
        Object.keys(this.$i18n.messages).map((key) => {
          let that = this;
          axios.get('/data/Schools/' + key + '.json').then(function (response) {
            that.schoolLangs.push({ lang: key, school: response.data })
          });
        });
      },
      getMiscLangs() {
        Object.keys(this.$i18n.messages).map((key) => {
          let that = this;
          axios.get('/data/' + key + '.json').then(function (response) {
            that.miscLangs.push({ lang: key, misc: response.data })
          });
        });
      }
    },
  }
</script>